<template>
    <cp-select
        :config="config"
        item-value="id"
        item-text="name"
        clearable
        :customSelection="true"
        v-on="$listeners"
        v-bind="attrs"
    >
        <template v-slot:selection="{ item }">
            {{ item.name }}
        </template>
    </cp-select>
</template>

<script>

export default {
    props: {
        routeHoldings: {
            type: Object,
            required: false,
            default: () => { return {route: 'v2.core.holdings'} },
        },
        config: {
            type: Object,
            required: false,
            default: () => { return {} },
        }
    },

    created() {
        this.init();
    },

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione uma Holding',
                name: name || "select-holding"
            }, ...attrs };
        },
    },

    methods: {
        init() {
            this.config.route = this.routeHoldings.route;
        },
    }
}
</script>